// extracted by mini-css-extract-plugin
module.exports = {"infoTooltip":"HeroBannerShopSales_infoTooltip__c1FeL"};